import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import { useHistory, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import React, { useState, useEffect } from "react";
import "./Header.css";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  let userName = localStorage.getItem("username");

  useEffect(() => {
    if (userName !== null) {
      setIsLoggedIn(true); // Use setIsLoggedIn to update the state
    }
  }, [userName]);
  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
  const history = useHistory();
  const handleClick = () => {
    history.push("/");
  };
  return (
    <Box className="header">
      <Box className="header-title">
        <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
      {children}
      {hasHiddenAuthButtons ? (
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={handleClick}
        >
          Back to explore
        </Button>
      ) : (
        <>
          {isLoggedIn ? (
            // If logged in, display Logout button
            <Stack direction="row" spacing={2}>
              <Stack direction="row" spacing={1}>
                <Avatar
                  src="../../public/avatar.png"
                  sx={{ width: 35, height: 35 }}
                  alt={userName}
                />
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  color="text.secondary"
                >
                  {userName}
                </Box>
              </Stack>
              <Button variant="text" onClick={handleLogout}>
                Logout
              </Button>
            </Stack>
          ) : (
            // If not logged in, display Login and Register buttons
            <>
              <div className="btns">
                <Link to="/login">
                  <Button className="explore-button">Login</Button>
                </Link>
                <Link to="/register">
                  <Button className="button" variant="contained">
                    Register
                  </Button>
                </Link>
              </div>
            </>
          )}
        </>
      )}
    </Box>
  );
};

export default Header;
